<template>
  <f7-page id="axsr-landingpage" name="axsr-landingpage" @page:beforein="beforein" @page:beforeout="beforeout" @page:afterin="afterin" class="bg-color-white" :class=" isShowContent ? '' : 'd-none'">
    <f7-navbar class="view-mobile bg-color-white axs-landingpage">
      <div class="text-center w-100">
        <img :src="require('@/assets/img/logo-wandr_e.svg')" style=""  class="logo"/>
      </div>
    </f7-navbar>

    <f7-block class="text-center">
      <transition name="fade" class="">
        <f7-card
            class   ="alert alert-danger mb-20"
            v-show  ="alertCard.show"
        >
          <f7-card-header>
            <span class="text-align-left" v-html="alertCard.title"></span>
          </f7-card-header>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>

      <div class="mb-md">
        <img :src="require('@/assets/img/axsr/lp-mobile-phone-image.png')" class=""/>
      </div>

      <div class="fw-medium fs-20 b mb-md break-word" v-html="text1"></div>

      <div class="mb-xl">
        <f7-button large fill class="bg-color-red2 text-color-white mb-20 display-flex align-items-center justify-content-center b fs-16" @click="singpassRegister" :disabled="false">
          <span v-html="singpassButton"></span>
        </f7-button>
      </div>
      

      <hr class="mb-md" style="border-top: solid 1px #EFEFEF">

      <div class="fw-bold fs-20 mb-md" v-html="text2"></div>

      <div class="">
        <f7-list no-hairlines class="beneficiary-list-2 feature-list no-outlines">
          <f7-list-item v-for="item in featureList" :key="item.id"  class="list-content-row">
            <div class="row no-gap w-100">
              <div class="col-media" style="">
                <img :src="require('@/assets/img/axsr/' + item.imgName +'.png')"/>
              </div>
              <div class="col-details">
                <div class="item-title text-align-left">{{item.title}}</div>
                <div class="fs-14 text-color-gray text-align-left" v-html="item.description"></div>
              </div>
            </div>
            
          </f7-list-item>
        </f7-list>
      </div>

      <div class="my-2 re-anchor-wrapper">
        <Recaptcha v-if="isShowRecaptchaV2 && sitekeyV2 != ''" :sitekey="sitekeyV2" name="login" />
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
  import TokenService from '../services/token-service';
  import ApiService from '../services/api-main';
  import { mapActions, mapGetters } from "vuex";
  import Recaptcha from '../components/Recaptcha.vue';
  import { dateHelper } from '@/plugins/helper';
  //import store from '../store'

  export default {
    data(){
      return {
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        isShowRecaptchaV2     : false,
        isNextButtonValid     : true,
        dvc                   : this.$f7.device,
        text1                 : "",
        text2                 : "",
        featureList           : [],
        singpassButton        : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        isShowErrorMsg        : false,
        errMsg                : "",
        isGetSingpassUrl      : false,
        isSkipPartnerValidationTmp : false,
        isShowContent : false,
      }
    },
    mounted(){
      //console.log("mounted windows location : "+window.location.host)
      /*
      if(window.location.host == "wandrepartner.p2hdevworks.com"){ // stg axs: wandrepartner.p2hdevworks.com, stg wandr-e: wandre.p2hdevworks.com
        window.location.host = "wandre.p2hdevworks.com";
      }else if(window.location.host == "partner.wandr-e.com"){ // prod
        window.location.host = "sendmoney.wandr-e.com";
      }
      */

      /*
      const appRedirPath = this.$api.misc.checkDeviceRedirect(this.dvc)
      if(appRedirPath){ window.location.href = appRedirPath; return; }
      */

      //this.showAlert(true, this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK})); // for err msg testing 

      this.text1 = this.$t('axs-lp-text-1')
      this.text2 = this.$t('axs-lp-text-2')

      const singpassImgURL = this.getImg('icon/icon-singpass.svg')
      this.singpassButton = this.$t('login-singpass-button-register', [singpassImgURL])

      this.featureList = [
        {'id': 1, 'title': this.$t('axs-lp-feature-title-1'), 'description': this.$t('axs-lp-feature-desc-1'), 'imgName' : 'lp-fee-icon'},
        {'id': 2, 'title': this.$t('axs-lp-feature-title-2'), 'description': this.$t('axs-lp-feature-desc-2'), 'imgName' : 'lp-clock-icon'},
        {'id': 3, 'title': this.$t('axs-lp-feature-title-3'), 'description': this.$t('axs-lp-feature-desc-3'), 'imgName' : 'lp-time-tracking-icon'}
      ];

      this.setIsAxsr(true)
      console.log("landingpage mounted : is AXS ? "+this.isAxsr+" ## skip validation ? "+this.isSkipPartnerValidation)
      this.toggleFooterVisibility(true)

      this.determineAppBranchId(this.dvc.desktop, true)

      const rc = this.$f7route.query['rc'];

      if(rc && rc.trim() != ""){
        this.setReferral(rc);
      }

      /*this.getRecaptchaKey().then(()=>{
        if(this.sitekey != "" && this.sitekeyV2 != ""){
            this.loadScriptByURL("recaptcha-key", "https://www.google.com/recaptcha/api.js?render="+this.sitekey, function () {
              console.log("script loaded");
            });

            var registrationData = store.state.registration;
            registrationData.recaptchaV2 = "";

            this.forceRerender();
        }
      });
      */

      this.setSingpassUrl("");
      window.regMyInfoComplete = this.regMyInfoComplete
      window.checkClosedWindowState = this.checkClosedWindowState

      console.log("mounted, skip validation ? "+this.isSkipPartnerValidation)
      this.isSkipPartnerValidationTmp = this.isSkipPartnerValidation
    },
    methods: {
      ...mapActions('auth', ['refreshToken', 'setMaintenanceMode', 'resetLoginState']),
      ...mapActions('misc', ['determineAppBranchId', 'setGuestBgMode']),
      ...mapActions('registration', [
            'resetRegistrationState',
            'getRecaptchaKey',
            'getToken',
            'getRegisterMyInfoUrl',
            'setSingpassUrl',
            'setReferral',
            'setIsAxsr',
            'setAxsIsRegisterError',
            'setAxsRegisterErrorMsg',
            'setIsAxsRegisterIdExist',
            'setIsAxsCrn',
            'setIsAxsSingpassToken',
            'setIsSkipPartnerValidation'
        ]),
      ...mapActions('myinfo', [
        'setAddress',
        'setDob',
        'setEmail',
        'setEmployerName',
        'setEmploymentSector',
        'setFullname',
        'setGender',
        'setIdentificationNo',
        'setNationality',
        'setOccupation',
        'setPassExpiryDate',
        'setPassStatus',
        'setPassType',
        'setResidentialStatus',
        'setEnabledField',
        'setMyInfoState',
        'setMyInfoCode',
        'setRouterTo',
      ]),
      changeTheme(e){
        let $$ = this.Dom7;
        const el = $$("html");
        e.target.checked
          ? el.addClass("theme-dark")
          : el.removeClass("theme-dark");
      },
      getImgUrl(){
          return require('../assets/img/flags/flag_189.png')
      },
      async loadResponse() {
        console.log("start load response... : "+this.isSkipPartnerValidation);

        var partnerCode         = this.$f7router.currentRoute.query.partnerCode || ''
        var sessionId           = this.$f7router.currentRoute.query.sessionId || ''
        var partnerCustomerId   = this.$f7router.currentRoute.query.partnerCustomerId || ''
        var customerId          = this.$f7router.currentRoute.query.customerId || ''
        var signature           = this.$f7router.currentRoute.query.signature || ''
        var url                 = this.$f7router.currentRoute.url || ''
        

        // PARTNER CODE
        if (partnerCode != undefined && partnerCode != '') {
          ApiService.saveFormData("axsQueryPartnerCode", partnerCode)
        } else {
          partnerCode = ApiService.getFormData("axsQueryPartnerCode")
        }

        // SESSION ID
        if (sessionId != undefined && sessionId != '') {
          ApiService.saveFormData("axsQuerySessionId",   sessionId)
        } else {
          sessionId = ApiService.getFormData("axsQuerySessionId")
        }

        // PARTNER CUSTOMER ID
        if (partnerCustomerId != undefined && partnerCustomerId != '') {
          ApiService.saveFormData("axsQueryPartnerCustomerId",partnerCustomerId)
        } else {
          partnerCustomerId = ApiService.getFormData("axsQueryPartnerCustomerId")
        }

        // CUSTOMER ID
        if (customerId != undefined && customerId != '') {
          this.setIsAxsCrn(true)
          ApiService.saveFormData("axsQueryCustomerId",customerId)
        } else {
          ApiService.removeFormData("axsQueryCustomerId");
          this.setIsAxsCrn(false)
          //customerId = ApiService.getFormData("axsQueryCustomerId")
        }

        // SIGNATURE
        if (signature != undefined && signature != '') {
          ApiService.saveFormData("axsQuerySignature",signature)
        } else {
          signature = ApiService.getFormData("axsQuerySignature")
        }

        try {
          if(this.isSkipPartnerValidation === false){
            console.log("here 1 : "+this.isSkipPartnerValidation)
            this.showPreloader();
            const validatePromiseResult = await this.$api.customer.validatePartnerCustomerDetails(partnerCode, sessionId, partnerCustomerId, customerId, signature, url)

            console.log("RESULT : ", validatePromiseResult)

            // 13003 - customer not found || (13000 & p2hCustomerId = 0) - AXS not passing customerId
            if(validatePromiseResult.status == "13003" || (validatePromiseResult.status == "13000" && validatePromiseResult.result.p2hCustomerId == 0)){
              console.log("redirect to registration page : ", this.Dom7('#axsr-landingpage.page-current'));
              /*
                do nothing, since registration button is on the current page.
                let user click the singpass register button manually
              */

              ApiService.removeFormData("axsQueryCustomerId");
              this.isShowContent = true
              this.hidePreloader();
            }
            // 13000 & p2hCustomerId > 0 - AXS passing customerId
            else if(validatePromiseResult.status == "13000" && validatePromiseResult.result.p2hCustomerId > 0){
              console.log("redirect to login page");
              this.hidePreloader();
              this.$f7router.navigate("/axsr-login");
            }
            // 13001 - partner not found || 13002 - invalid signature || 13004 - unexpected error
            else if(validatePromiseResult.status == "13001" || validatePromiseResult.status == "13002" || validatePromiseResult.status == "13004"){
              // redirect to error page
              console.log("validate partner error status");
              this.$f7.sheet.close()
              this.hidePreloader();
              this.$f7router.navigate("/error", {
                  props: {
                      errorCode: validatePromiseResult.status
                  }
              });
            }else{ // other undefined errors
              // redirect to error page
              console.log("validate partner error undefined");
              this.$f7.sheet.close()
              this.hidePreloader();
              this.$f7router.navigate("/error", {
                  props: {
                      errorCode: "error undefined"
                  }
              });
            }
            this.setIsSkipPartnerValidation(false);
          }else{
            console.log("partner validation skipped")
          }
        } catch (e) {
          this.hidePreloader();
          console.log("load response error : ", e)
          console.log(e.errorCode)
        }
      },
      async beforein(){
        this.setGuestBgMode(true)

        if(this.isAxsSingpassToken){
          // clear singpass token
          TokenService.removeToken()
        }

        console.log("FUll URL : ", this.$f7.views.main.router)

        this.isShowErrorMsg = this.axsIsRegisterError;
        this.errMsg = this.axsRegisterErrorMsg;

        this.resetLoginState();
        this.resetRegistrationState();
        console.log("maintenanceMode " + this.maintenanceMode)
        this.setMaintenanceMode(false);

        console.log("landingpage beforein 1 : is AXS ? "+this.isAxsr)
        this.setIsAxsr(true)
        console.log("landingpage beforein 2 : is AXS ? "+this.isAxsr)

        this.determineAppBranchId(this.dvc.desktop, true)

        this.setIsSkipPartnerValidation(this.isSkipPartnerValidationTmp)
        
        //console.log("beforein TOKEN : "+TokenService.getToken())
        if (TokenService.getToken()) {
          //console.log("landingpage beforein, TOKEN exist : "+TokenService.getToken())

          //this.Dom7('#axsr-landingpage.page-current').removeClass("d-none")
          this.isShowContent = true

          let valid = this.checkTokenExpiry(true, this.navigateHome)
          if (valid) {
            console.log("landingpage beforein, TOKEN exist & valid")
            await this.refreshToken()
            if(this.loggedIn) {
              ApiService.mount401Interceptor();
              this.navigateHome();
              if(this.$store.state.misc.redirectToPath != '') {
                setTimeout(() => {
                  const paths = this.$store.state.misc.redirectToPath.split("?");
                  this.navigateRoute(paths[0], (paths.length == 1)?undefined:paths[1]);
                }, 3000)
              }
            }
          }else{ // check redirection
            console.log("landingpage beforein, TOKEN exist & invalid")
            if(this.isSkipPartnerValidation === false){
              TokenService.removeToken()
              await this.loadResponse();
            }else{
              //this.Dom7('#axsr-landingpage.page-current').removeClass("d-none")
              this.isShowContent = true
            }
          }
        }else{ // check redirection
          if(this.isSkipPartnerValidation === false){
            await this.loadResponse();
          }else{
            this.isShowContent = true
            
            this.setIsSkipPartnerValidation(false) // reset back to false
          }
        }
        
        if(this.isShowErrorMsg){
          this.showAlert(true, this.errMsg);
        }
      },
      beforeout(){
        this.setGuestBgMode(true) // <-- set to true for WA-355
      },
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async getRecaptchaKey(){
        this.showPreloader();
        const recaptchaKey = await this.$api.registration.getRecaptchaKey();

        if(recaptchaKey){
          if(recaptchaKey.result.siteKey && recaptchaKey.result.siteKeyV2){
            console.log("GOT THE SITEKEY")
            this.sitekey = recaptchaKey.result.siteKey;
            this.sitekeyV2 = recaptchaKey.result.siteKeyV2;
            this.hidePreloader();
          }else{
            console.log("DISPLAY ERROR MSG FOR SITEKEY NULL")
            this.hidePreloader();
            this.$f7.dialog.alert(this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
          }
        }else{ // recaptchaKey == false -> WS error
          this.sitekey = "";
          this.sitekeyV2 = "";
        }
        this.hidePreloader();

      },
      loadScriptByURL(id, url, callback){
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      },
      async singpassRegister(){
        console.log("singpassRegister : is AXS ? "+this.isAxsr);
        
        const self = this;
        self.showPreloader();
        self.isGetSingpassUrl = true;

        if(self.$f7.device.ios && !self.isMyInfoUseInAppBrowser() && self.checkWindow == undefined) {
          self.checkWindow = window.open('about:blank', '_blank', "fullscreen=1");
        }

        const reqTokenSingpass = await this.$api.registration.getTokenSingpass();

        if(reqTokenSingpass.status == "WN00103"){
          self.setIsAxsSingpassToken(true)
          const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
          const myInfoUrlPromise = await this.$api.registration.getRegisterMyInfoUrl(isUsingInAppBrowser);

          self.registerMyInfoUrl = myInfoUrlPromise.value;
          self.setSingpassUrl(myInfoUrlPromise.value);

          self.setRouterTo('axs-landingpage');

          if(isUsingInAppBrowser) {
            self.openMyInfoInMobile(self.singpassUrl);
            self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
              if(isUserCancel) {
                self.setIsAxsSingpassToken(true)
                self.regMyInfoCancel(false);
              } else {
                self.setIsAxsSingpassToken(false)
                self.regMyInfoComplete((state != '' && code != ''), state, code);
              }
            });
          } else if(self.checkWindow !== undefined) {
            self.checkWindow.location.replace(self.singpassUrl);
          } else {
            self.checkWindow = window.open(self.singpassUrl, '_blank', "fullscreen=1");
          }

          if(!isUsingInAppBrowser) {
            self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.regMyInfoCancel(false);} }, 1000);
          }
          //self.hidePreloader();
        }else{ // GENERAL EXCEPTION
          //this.showAlert(true, reqToken.status)
          if(self.checkWindow !== undefined) {
            self.checkWindow.close();
            self.checkWindow = undefined;
          }

          self.setIsAxsSingpassToken(false)
          this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
          console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqTokenSingpass.status);
          this.hidePreloader();
        }
      },
      async regMyInfoComplete(isNextPage, myInfoState, myInfoCode){
        this.isForceClosed = false;
        this.setMyInfoState(myInfoState);
        this.setMyInfoCode(myInfoCode);
        this.closePopupOnMobile();
        
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }

        if(isNextPage){
          this.showPreloader();

          const myInfoDetailPromise = await this.$api.registration.getRegisterMyInfoDetail(this.isMyInfoUseInAppBrowser(), myInfoCode, myInfoState);

          if(myInfoDetailPromise.status == "4854"){
            this.setIsAxsSingpassToken(true)
            const myInfoData = myInfoDetailPromise.result;

            this.setAddress(myInfoData.address.streetAddress);

            // FORMAT DOB
            const dobVal = new Date(myInfoData.dateOfBirth);
            var formattedToday = '';
            if(dobVal instanceof Date && !isNaN(dobVal)) {
              const yyyy = dobVal.getFullYear();
              let mm = dobVal.getMonth() + 1; // Months start at 0!
              let dd = dobVal.getDate();

              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;

              formattedToday = dd + '-' + mm + '-' + yyyy;
            }
            //console.log("formattedToday 1 : "+formattedToday)
            this.setDob(formattedToday);
            // END OF FORMAT DOB

            this.setEmail(myInfoData.email);
            this.setEmployerName(myInfoData.employer);
            this.setEmploymentSector(myInfoData.industry);
            this.setFullname(myInfoData.name);
            this.setGender(myInfoData.gender);
            this.setIdentificationNo(myInfoData.identificationNo);
            this.setNationality({id: myInfoData.nationalityId, name: myInfoData.nationality});
            this.setOccupation(myInfoData.occupation);
            this.setPassExpiryDate(dateHelper.formatDateOnly(myInfoData.idExpiryDate));
            this.setPassStatus(myInfoData.idStatus || "");
            this.setPassType(myInfoData.identificationType);
            this.setResidentialStatus({id: myInfoData.residentialStatusId, name: myInfoData.residentialStatus || ""});
            this.setEnabledField(myInfoData.enabledField);

            this.$f7router.navigate("/register-myinfo-verify-detail");
            this.hidePreloader();
          }else if(myInfoDetailPromise.status == "1214"){
            // clear singpass token
            TokenService.removeToken()

            console.log("ID exist")
            this.setIsAxsRegisterIdExist(true)
            //this.setAxsIsRegisterError(true)
            //this.setAxsRegisterErrorMsg(this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            //this.showAlert(true, this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            this.$f7router.navigate("/axsr-login");
            this.hidePreloader();
          }else if(myInfoDetailPromise.status == "0104"){
            // clear singpass token
            TokenService.removeToken()

            console.log("General exception")
            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            this.hidePreloader();
          }else{
            // clear singpass token
            TokenService.removeToken()

            console.log("get details: ERROR -> "+myInfoDetailPromise.status);
            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            this.$f7router.navigate("/customerDetails");
            this.hidePreloader();
          }


        }else{ // reload register enter details page
          console.log("reload page")

          // clear singpass token
          TokenService.removeToken()

          //this.$f7router.navigate("/customerDetails");
          this.$f7router.refreshPage({
            url: '/customerDetails'
          });
          this.setAxsIsRegisterError(true);
          this.setAxsRegisterErrorMsg(this.$t('regis-myinfo-unavailable-error'));
          this.showAlert(true, this.$t('regis-myinfo-unavailable-error'));
        }
      },
      async regMyInfoCancel(isNextPage){
        // clear singpass token
        TokenService.removeToken()

        if(!isNextPage){
          clearInterval(this.checkTimer);
          if(this.checkWindow !== undefined) {
            this.checkWindow.close();
            this.checkWindow = undefined;
          }
        }

        this.hidePreloader();
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      checkClosedWindowState(){
        console.log("checkClosedWindowState : "+this.checkWindow.closed)
        if(this.checkWindow.closed){
          console.log("child window closed")
        }
      },
      forceRerender() {
        this.isShowRecaptchaV2 = false;
      },
      navigateHome(){
        this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });
      },
    },
    components: {
      Recaptcha
    },
    computed: {
      ...mapGetters('auth', ['loggedIn','maintenanceMode']),
      ...mapGetters('registration', ['singpassUrl','email','isAxsr','axsIsRegisterError','axsRegisterErrorMsg','isAxsSingpassToken','isSkipPartnerValidation']),
      ...mapGetters('myinfo', [
          'myInfoState',
          'myInfoCode',
        ])
    },
  }
</script>